import {createStrokeSVG} from './TEMPLATE'

// tabler: file-text
export const PageText_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M14 3v4a1 1 0 0 0 1 1h4',
    'M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2',
    'M9 9l1 0',
    'M9 13l6 0',
    'M9 17l6 0',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
